// USES getVariantIdFromUrl() and GdcAddCaseToCart() in global.js

function handleLabelsAddon(event) {
  event.preventDefault()
  event.stopPropagation()

  const addonCheckbox = document.querySelector('#labels-add-on-checkbox')
  const selectedCaseSize = document.querySelector('.gdc-product-quantity-option.active')
  const quantity = parseInt(selectedCaseSize.dataset.caseSize)
  const productId = parseInt(event.target.dataset.productId)
  const selectedVariantId = parseInt(getVariantIdFromUrl())

  const productItem = {
    id: selectedVariantId ? selectedVariantId : productId,
    quantity: quantity,
  }

  const customLabelsItem = {
    id: 53496788549905,
    quantity: 1,
  }

  const items = addonCheckbox.checked ? [productItem, customLabelsItem] : [productItem]
  
  console.log("productItem ", productItem);
  console.log("customLabelsItem ", customLabelsItem);
  console.log("items ", items);
  
  GdcAddCaseToCart(items) 
}
